// Route: /search — глобальный поиск.
import { tolerantSearch } from "@studyhub/shared/utils/tolerant-search";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SearchPage } from "@/components/search/search-page";
import type { SearchResultType } from "@/components/search/types";
import { PagePendingFallback } from "@/components/shared/page-pending-fallback";

const searchSchema = z.object({
	q: z.string().optional(),
	// Литералы, а не производный enum: из этой схемы TanStack Router выводит
	// типы URL-параметров, а `z.enum` поверх рантайм-массива их обнуляет
	// (та же причина, по которой статичен `COURSE_WORKSPACE_VIEWS`).
	// Состав обязан совпадать с `SearchResultType`; расхождение ловит
	// присваивание `initialType` ниже — оно не скомпилируется.
	type: z.enum(["material", "collection", "note", "flashcard", "quiz", "topic"]).optional(),
	demo: z.enum(["loading", "empty", "many-results"]).optional(),
});

export const Route = createFileRoute("/search")({
	validateSearch: tolerantSearch(searchSchema),
	component: SearchRoutePage,
	pendingComponent: PagePendingFallback,
});

function SearchRoutePage(): React.ReactElement {
	const search = Route.useSearch();
	return (
		<SearchPage
			initialQuery={search.q ?? ""}
			initialType={(search.type as SearchResultType | undefined) ?? "all"}
			demo={search.demo ?? null}
		/>
	);
}
